module.exports = __webpack_public_path__ + "img/Unidad14-1.1092e89e.png";